import { SHIPPING_TYPE_OPTIONS } from "../constants"

export const getShippingTypeLabel = (shippingType: string): string => {
  const option = SHIPPING_TYPE_OPTIONS.find((opt) => opt.value === shippingType)
  return option?.label || shippingType
}
